import { render, staticRenderFns } from "./twlhc.vue?vue&type=template&id=6aab1996&scoped=true"
var script = {}
import style0 from "./twlhc.vue?vue&type=style&index=0&id=6aab1996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab1996",
  null
  
)

export default component.exports